module.exports = __webpack_public_path__ + "img/2.ba88714.svg";